import { useMemo } from 'react'
import getTimezoneOffset from '../../utils/get-timezone-offset'
import useTimer from '../../hooks/use-timer'
import { subHours } from '../../utils/date-service'

function pad(num) {
  return String(num).padStart(2, 0)
}

function formatTime({ days, hours, minutes, seconds }) {
  return days >= 1
    ? `${days}d ${pad(hours)}h ${pad(minutes)}m`
    : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

export default function RemainingTime({ endDate, timeZone, onExpire }) {
  const zonedTimeToLocal = useMemo(() => subHours(endDate, getTimezoneOffset(timeZone, endDate)), [
    endDate,
    timeZone,
  ])

  const { days, hours, minutes, seconds } = useTimer({ expiryDate: zonedTimeToLocal, onExpire })

  return formatTime({ days, hours, minutes, seconds })
}
